import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { useSelector } from 'react-redux';

const brandLogos = [
  "brand_1_1.svg", "brand_1_2.svg", "brand_1_3.svg", "brand_1_4.svg",
  "brand_1_5.svg", "brand_1_6.svg", "brand_1_7.svg", "brand_1_8.svg",
  "brand_1_4.svg", "brand_1_3.svg", "brand_1_2.svg", "brand_1_1.svg"
];

const Branding = () => {
    const eventData = useSelector((state) => state.event.eventData);
    const brand = eventData.brand    ;
console.log("brand",brand)
  return (
    <div className="brand-area overflow-hidden space">
      <div className="container th-container">
      <Swiper
  modules={[Autoplay]}
  autoplay={{ delay: 0, disableOnInteraction: false }}
  speed={5000} // adjust to make it slower or faster
  loop={true}
  freeMode={true} // smooth scrolling
  grabCursor={true}
  slidesPerView="auto"
  spaceBetween={30}
  breakpoints={{
    0: { slidesPerView: 1 },
    576: { slidesPerView: 2 },
    768: { slidesPerView: 3 },
    992: { slidesPerView: 4 },
    1200: { slidesPerView: 6 },
    1400: { slidesPerView: 8 },
  }}
  className="brandSlider1"
>


          {brand.map((logo, index) => (
            <SwiperSlide key={index}>
              <div className="brand-box">
                <a href="#">
                  <img className="original" src={logo.imageKey} alt="Brand Logo" />
                  <img className="gray" src={logo.imageKey} alt="Brand Logo" />
                </a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Branding;
